export default {
  login: {
    inputaccount: 'Please enter your account number',
    inputpwd: 'Please enter your password',
    login: 'Log in',
    lospass: 'Forgot Password',
    openaccont: 'Sign Up',
    inputphonemail: 'Please enter mobile number/email address',
    recode: 'Please enter the verification code',
    nologin: 'You are not logged in. Please log in and try again',
    verification: 'Verification code',
    newpass: 'Please enter a new password',
    pemainotnull: 'Mobile number/email cannot be blanked',
    asave: 'SAVE',
    checkphoneemail: 'Please check if the phone number or email address is correct',
    rulepass: 'Should be between 8-30 characters & alphanumeric',
    rulecode: 'The verification code format is incorrect!',
    verinotnull: 'Verification code cannot be blanked!',
    serviceerror: 'Abnormal service, please contact customer service!',
    tafter: 'Try again later',
    serviceerr: 'Service error, please contact customer service!',
    acconly: 'To login to client center can be only enter the mobile phone number, MT5 account number or email address',
    logsucc: 'Log in successfully',
  },
  home: {
    logout: 'Log out',
    customer: 'Chat with us',
    mcwebsite: 'Magic Compass official website',
    welcome: 'Welcome!',
    racc: 'Real Account',
    dacc: 'Demo Account',
    ihome: 'Home',
    lastlog: 'Last login',
    balance: 'Balance',
    networth: 'Equity',
    margin: 'Free Margin',
    injection: 'Deposit',
    withdraw: 'Withdrawal',
    customerstatus: 'IB Client Situation',
    todaynews: "Today's news",
    commissions: "Today's Commissions",
    newcust: 'New Client',
    newdeposits: 'Deposit by your Clients',
    subordinate: 'There are all overview of the general clients and sub IB under your account',
    cdetails: 'Commission Details',
    more: 'More',
    cinews: 'Deposit',
    ordernum: 'Order Number',
    amount: 'Amount',
    deposittime: 'Deposit time',
    depositmethod: 'Channel',
    status: 'Status',
    dynamics: 'Withdrawal',
    fee: 'Charges',
    applicationt: 'Application Time',
    operation: 'Operation ',
    cantapp: 'Cancellation Application',
    lateann: 'Announcement',
    nodate: 'No Data',
    mccs: 'Magic Compass Customer Service',
    equivalent:
      'You can practice on a risk-free demo account, and while trading and funds are virtual so that cannot be withdrawal. If you have been understanded rules, you can active your real account and start trade!',
    perfected:
      'In the actual battlefield, the capital injection will no longer be restricted, and you can withdraw money immediately after earning real money. If you have mastered the basic rules and perfected your identity information, you can activate real account and try your hand at it!',
    buttonbelow: 'Click the button below to creat a demo account.',
    identity: 'Click the button below to complete the identity documents to active the real account.',
    araccount: 'Activate real account',
    previous: 'the previous',
    next: 'the next',
    iprotect: 'For the security reason, please complete verification of your identity before you deposit',
    goautht: 'Go to upload your Identity documents',
  },
  und: {
    undername: 'Sub IBs List',
    tracc: 'Trading Account',
    acctype: 'Account Type',
    regdate: 'Registration Date',
    tinfom: 'Trading Information',
    lowlevel: 'Modify Lower-level Rebates',
    lowlevels: 'Institutional Client Upgrade',
    export: 'Export',
    cgrade: 'Customer Upgrade',
    rebate: 'When you set the rebate (rebate/lot) for products of sub IBs, which cannot exceed your own rebate amount',
    cname: 'Full Name',
    frebate: 'Forex Rebate',
    ulot: 'USD/lot',
    srebtae: 'Stock Rebate:',
    indexc: 'Index Class:',
    chinar300: 'CHINA300 Rebate：',
    chinar50: 'CHA50 Rebate',
    rebates: 'Other Index Rebates:',
    comclass: 'Commodity Class',
    lgrebate: 'GOLD Rabate:',
    lsrebate: 'SILVER Rabate',
    usoilrebate: 'USOIL Rabate:',
    ukoilrebate: 'UKOIL Rabate',
    cryrebates: 'Cryptocurrency Rebates:',
    btccomm: 'BTC100x Rabate:',
    otherrebates: 'Other Cryptocurrency Rebates:',
    cancel: 'Cancel',
    confirm: 'Confirm',
    Reset: 'Reset',
  },
  details: {
    inscustom: 'IB',
    ordcustom: 'General Client',
    return: 'Return',
    funinfo: 'Funding Information',
    position: 'Holding Position',
    balance: 'Balance',
    networth: 'Equity',
    tradtype: 'Symbol',
    transetype: 'Type',
    transets: 'Type：',
    lotsize: 'Size',
    opetime: 'Opening Time',
    opeprice: 'Opening Price',
    closet: 'Closed Time',
    closets: 'Closed Time:',
    stoptake: 'SL/TP',
    invfee: 'Swap',
    closeposition: 'Closed Position',
    to: 'to',
    startd: 'Start Date',
    endd: 'End Date',
    choose: 'Please Select',
    enterc: 'Please Enter Content',
    query: 'Search',
    proloss: 'Profit',
    tataltrance: 'Total Volume',
    lindgold: 'GOLD： ',
    lindgolds: 'GOLD',
    usoil: 'USOIL：',
    usoils: 'USOIL',
    forexchange: 'FX：',
    china300: 'China 300：',
    china50: 'China 50：',
    china300s: 'China 300',
    china50s: 'China 50',
    lonsilv: 'SILVER：',
    lonsilvs: 'SILVER',
    britishoil: 'UKOIL：',
    britishoils: 'UKOIL',
    stock: 'Stock：',
    oindex: 'Other index：',
    btc: 'Bitcoin：',
    otherbtc: 'Cryptocurrencies：',
    closepr: 'Closing Price',
    proloass: 'Profit',
    settlecomm: 'Settlement Commissions',
    settlecomms: 'Settlement Commissions（$）',
    ordnum: 'Order Number',
    ordite: 'Symbol',
    salet: 'Type',
    traclient: 'Account Number',
    insclients: 'IB clients',
    ownrebate: 'IB Rabate Rule',
    lowerlev: 'Sub IBs Rebate Rule/ TP',
    cumulateive: 'Cumulative Deposit',
    Cumulateivein: 'Cumulative Withdrawal',
    netdeposit: 'Net Deposit',
    opetdate: 'Operation Date',
    opettype: 'Operation Type',
    amount: 'Amount ($)',
    amountr: 'Amount (￥)',
    lweek: 'Latest Week',
    lmonth: 'Latest Month',
    lthrmon: 'Latest 3 Month',
    totaltra: 'Volume',
  },
  commiss: {
    comman: 'Commissions',
    ewallet: 'E-wallet',
    comtype: 'Commission Settlement Type',
    walletbal: 'E-wallet (Balance)',
    transfermt4: 'Transfer to MT5：',
    transferamo: 'Amount：',
    amountomt4acc: 'Amount',
    submit: 'SUBMIT',
    tips: 'Note',
    tips1: 'While internal transfers from e-wallet to MT5 account are free-of-charge.',
    tips2: 'While internal transfers from e-wallet to MT5 account are submitting application only once a day.',
    lgus5: 'When transferring to a bank card, the minimum amount must be ≥$5',
    process: 'You currently have a withdrawal request being processed...',
    vuedetail: 'Check the details',
    totalcomm: 'Total Settlement Commissions',
    ownlow: 'Sub IBs Rabate Rule',
  },
  report: {
    underreps: 'Holding Positions',
    underrep: 'Report',
    selecttype: 'Please Select Symbol',
    ordnumber: 'Please Enter Order Number',
    entaccname: 'Please Enter MT5 Account Number/Full Name',
    selecttt: 'Please Select Trading Type',
    totalposi: 'The Number of Closed Orders',
    totalposih: 'The Closed Orders of Lots',
    clientsta: 'Closed Positions',
    totalnumposc: 'The Number of Closed Orders',
    totalnumposl: 'The Closed Orders of Lots',
    totalproloss: 'The PNL of Closed Orders',
    interest: 'Interest',
    clifunstat: 'Funds',
    entoptuser: 'Please Enter the Operation User',
    totalwithdra: 'The Number of Withdrawal',
    totalnumdep: 'The Total Number of Deposit',
    totalwitham: 'Total Withdrawal Amount',
    totaldepam: 'Total Deposit Amount',
    opttime: 'Operation Time',
    opeuser: 'Operating User',
    losscus: 'The PNL Repot',
    totalnumtra: 'Total Number of Transactions',
    tradet: 'Trading Record',
    travolstavar: 'Trading Volume of Symbols',
  },
  link: {
    pulllink: 'Referral Link',
    tpsi: 'Reminder: It is usually suitable for use in blogs, forums, chat tools, websites, and emails.',
    copy: 'Copy',
    qqlink: 'After clicking "Copy", you can paste the promotion link into the QQ group or send it to your QQ friends',
    weblink: 'Share the content to your Weibo, Renren, Space, and easily experience the fun of making money',
    morelink: 'After clicking "Copy", paste the promotion link to each post bar or forum',
    copysucc: 'Copy Successfully!',
  },
  basic: {
    realname: 'Document Verification',
    idpic: 'ID Documents',
    upload: 'Upload',
    carderr:
      'We cannot recognize character of your ID card, please re-upload and try again. You may also enter information by yourself, we will review it as soon as possible.',
    manent: 'Manually Entering Information',
    cheinfo:
      'Please check the following information. If it does not match the certificate information you submitted, you can resubmit the picture, or manually modify it for the manual verfication channel.',
    repairre: 'Edit Recognition Result',
    name: 'Name',
    certty: 'Document type',
    antwallet: 'Ant wallet verification',
    identifie: 'to be identified',
    entname: 'Please enter your name',
    idnmu: 'ID Number',
    idcard: 'ID Card',
    passport: 'Passport',
    other: 'Other',
    eveare: 'Please select an event area',
    fairea: 'Failure Reason: ',
    safety: 'Due to the funding sercurity reason, please enter the correct information.',
    completing: 'After verify your documents, you will withdrawal on the client center.',
    max5m: 'Image File Formats: support jpg/png/jpeg format, and the image sizes cannot exceed 5MB.',
    Resubmit: 'Resubmit',
    automatic: 'Your identity information failed to pass automatic verification, you can choose',
    resubinfo: 'Check and modify the information,  and resubmit it;',
    correct:
      'If the information is confirmed to be correct, please use the manual verification channel, and the customer service staff will assist you to solve this problem as soon as possible.',
    cheinfomation: 'Check the information',
    subman: 'Submit for manual verification',
    onlineservice: 'Authentication failed, if you have any questions, please contact online customer service.',
    onlinecusser: 'Online customer service',
    entidnum: 'Please Enter the ID number',
    entcorrect: 'Please Enter the Correct ID Number',
    selectdoc: 'Please Select the Type of Document',
    cardfront: 'Front',
    cardback: 'Back',
    upfrontcard: 'Please upload the front of your ID card',
    upbackcard: 'Please upload the back of your ID card',
    notverified: 'Pending',
    verifica: 'Please wait while we are processing for you…',
    verpass: 'Approved',
    verfailed: 'Reject',
    otherdocu: 'Other Documents',
    sizemax5m: 'The image sizes cannot exceed 5MB.',
    frontdoc: 'Front of ID card',
    backdoc: 'Back of ID card',
    subing: 'Processing...',
    submit: 'Submit',
    allup: 'Please check your documents uploaded successfully',
    verwait: 'We are processing your request, please wait...',
    logexp: 'Time out, please login again',
    statement_text_title: 'Important Notice：',
    statement_text:
      "Filling in this questionnaire means that the client himself has accepted the questionnaire on risk tolerance, fully aware of the risk types of the investment products, and all investment decisions made by the client are based on the client's own judgment and unconditional commitment. You are solely responsible for all investment risks and related responsibilities.",
    toast: 'Questionnaire information is incomplete',
    nav_title: 'Transaction Evaluation Form',
    tip_text:
      'Before submitting the review documents, in order to ensure that you have understood the relevant risks of CFD product trading and judged your own investment situation, please fill in the following form according to your current situation:',
    van_button: 'Confirm Submission',
  },
  bank: {
    bankcard: 'Bank Card',
    name: 'Full Name: ',
    idnumber: 'ID number: ',
    banknumb: 'Bank Card Number: ',
    entbankcard: 'Please Enter Bank Card Number',
    bankname: 'Bank Name: ',
    bankloca: 'Bank Card Province: ',
    bankbran: 'Branch/Branch Name: ',
    bankphon: 'Reservation for Phone: ',
    entbranch: 'Please enter the branch/sub-branch name',
    entbranchs: 'Please enter the branch/sub-branch name',
    entbankmob: 'Please reservation for Phone',
    bic: 'Please enter Sort code/SWIF/BIC',
    entcorr: 'Please enter the correct mobile number',
    bankima: 'screenshot of bank card',
    proacco: 'The bank card you provided will be use to withdrawal, for the security reason, please ensure the information is correct.',
    banksub: 'If you would like to change bank card after we approved, please contact us',
    contactcus: ' Contact Us.',
    combind: 'Before you verify your bank card, please provide your Identity document first',
    entdigit: 'Please enter 6-19 digit bank card number',
    selregion: 'Please select Bank Card Province',
    entbankname: 'Please enter the bank name',
    entbanknames: 'Please enter the bank name',
    name2to50: 'Please enter Branch Name',
    upphoto: 'Please upload the front of your bank card',
    notverif: 'Pending',
    verified: 'Approved',
    failveri: 'Reject, please contact us',
    upfrontimag: 'Please upload the front of your bank card first',
    Confirm: 'Confirm',
    choose: 'Please Select',
    state_text: ['Pending', 'Passed', 'Failed'],
    noDataText: 'You have not bound a bank card',
    unbind_message: 'Are you sure you want to delete this bank card? ',
    updateSuccess: 'Set success',
    add_bank: 'Add bank card',
    default: 'default',
    default_button: 'Set as cash withdrawal card',
    unbind: 'unbind',
  },
  paw: {
    chapass: 'Reset Password',
    entnewpass: 'Enter New Password:',
    entpassagain: 'Enter New Password Again:',
    againentpass: 'Please Enter New Password Again',
    vercode: 'Verification Code:',
    bindphonef: 'Please bind your mobile number or email address first',
    notmatch: 'The password you entered do not match!',
    reasec: 'Resend After Seconds',
    getverifi: 'Get Verification Code',
  },
  dep: {
    Injection: 'Deposit',
    capamoun: 'Amount:',
    Dollar: 'USD',
    d600: '$600',
    d500: '$500',
    d300: '$300',
    d200: '$200',
    traaccount: 'Trading Account',
    equal: 'about',
    rmb: 'CNY',
    avaliable: 'You still can deposit ',
    time: 'times',
    madeonce: 'Demo account can only be deposit 10000 USD once a day',
    amountrmb: 'CNY amount is for reference only',
    capitalinj: 'This deposit button only can be use to trade for demo account, can not be withdrawal.',
    doubt: 'If you have any question, please free feel to contact us',
    call24line: 'or please call our 24-hour customer service hotline.',
    next: 'Next Step',
    selmet: 'Select Payment Method',
    WeChat: 'WeChat',
    Alipay: 'Alipay',
    paid: 'Actually paid',
    return: 'Return',
    payimm: 'Immediate Payment',
    complete30: 'We will close your order once you cannot payout within 30 minutes',
    ifexit: 'If the day exists',
    tran3: '3 transactions',
    notpaid: 'If there are 3 unpaid orders in the day, we will close your deposit function',
    platnotacc: 'According to AML policy, we cannot accept third party deposit, and we also do not support credit card payment method',
    allaccset:
      'Our accounts are settled in USD, and it base on the floating rate to exchange, CNY amount is for reference only. We suggest that please reserve space for floating rate to make sure your fund demand.',
    herebycon: 'I confirm that I am a legal account holder, and the money I deposited had nothing to do with illegal activities',
    hereconlegal: 'I confirm again that I will be using my legal account to deposit by myself.',
    entamount: 'Please Enter Amount',
    single50: 'Deposit amount is 50-700 USD once time',
    incamount: 'Incorrect Amount Format',
  },
  wit: {
    getmet: 'Getting withdrawal Method',
    perpat: 'We are currently reviewing your documents, please wait a moment...',
    tipens: 'Tips: For the funding security reason, please complete to verification before withdrawal!',
    available: 'Available Withdrawal Amount:',
    withdraw: 'Withdrawal Amount:',
    conrmb: 'About CNY:',
    huansuan: 'About USDT',
    witmeth: 'Withdrawal Method',
    selwithdra: 'Please select withdrawal method',
    uping: 'Uploading...',
    wechatpay: 'Get WeChat Payment Code:',
    click: 'Click',
    me: 'me',
    pay: 'pay',
    collpay: 'Money',
    qrcode: 'receive money',
    setamount: 'set amount',
    entrmb: 'Enter "Exchange to CNY" to show amount',
    cliok: 'Click confirm',
    reccode: 'Then take a screenshot of the receipt code',
    withqrcode: 'You can withdrawal through uploading the WeChat payment QR code',
    alicode: 'get Alipay payment Pay/Collect QR code method:',
    withdrawqr: 'You can withdrawal through uploading the Alipay payment QR code',
    payqracc: 'The payment QR code needs to be accompanied by the amount, otherwise the application may not be approved!',
    actualdiff:
      'The actual payment will be different depending on the channels provided by the partner merchants. If this payment method is not currently available, it may be credited to your bound bank card.',
    nohand: 'No handling fee for the first withdrawal of the month;',
    lessthan: 'For the second and above withdrawals in the month, if the withdrawal amount is less than US$100, a handling fee of US$5 will be deducted;',
    current: 'If there is currently an unfinished withdrawal order, a new withdrawal application cannot be submitted;',
    succdep: 'If there is a successful deposit within 24 hours, the withdrawal cannot be applied;',
    withdrawal:
      "The withdrawal will be reviewed and remitted during the service hours of the financial department (09:00-18:00 on working days), and generally arrives in the account within 1 working day; the specific arrival time still depends on the bank's processing speed, about 1-3 work. day to account.",
    less50: 'If the withdrawal amount is less than 50 USD, we will deduct 3 USD as the charge fee:',
    sessdeposit: 'The total transaction amount is less than the total deposit amount',
    necessary: 'It is necessary to deduct the amount of this withdrawal',
    asfee: 'as a fee',
  },
  fun: {
    details: 'Statement',
    capital: 'Total Deposits',
    Date: 'Date',
    Time: 'Time',
    Times: 'Date',
    staope: 'Status',
    totalwithdra: 'Total withdrawal:',
    wdrawamount: 'Amount',
    arrrmb: 'The Actual Amount in CYN',
    withdrawal: 'Withdrawal method',
    address: 'Wallet address:',
    apptime: 'Date',
    Cancel: 'Cancelled',
    Details: 'Details',
    orddetail: 'Order Details',
    pendingver: 'Aceepted',
    verifying: 'Processing',
    wisuccess: 'Success',
    wifaile: 'Reject',
    ordcannel: 'Order Cancelled',
    ordernumb: 'Order Number:',
    widrawam: 'Withdrawal:',
    hfee: 'Handling Fee:',
    appsubtime: 'Date:',
    orderstatus: 'Order Status:',
    remark: 'Comment:',
    remarks: 'Comment',
    All: 'All',
    ondep: 'Online Deposit',
    banktrn: 'Bank transfer',
    Mallpayment: 'Mall payment',
    QuickPayment: 'Quick Payment',
    Depositonline: 'Deposit Online',
  },
  pos: {
    posi: 'Position',
    travar: 'Symbol',
    buy: 'buy',
    sell: 'sell',
    holdtime: 'Date:',
    occ: 'Margin',
    curt: 'Trading History',
    Notes: 'Notes',
    closeto: 'PNL',
    notparti: 'You have not participated in this event',
    gotodep: 'Go to deposit and get rewards',
    actname: 'Name of activity:',
    acttime: 'Activity time:',
    '72hdep': 'Net deposit within 72 hours:',
    cashrew: 'Bonus level:',
    ucrels: 'USD Cash Release Status:',
    rewlev: 'In-kind reward level:',
    rediss: 'In-kind reward distribution status:',
    nameact: 'Name of activity:',
    timeact: 'Activity time:',
    recaward: 'Contact customer service to receive the award',
    rewdistr: 'In-kind reward distribution time',
    rewactdi: 'In-kind Rewards Actual Distribution Items',
    pending: 'pending',
    pendingr: 'pending release',
    issued: 'issued',
    expired: 'expired',
    notstandard: 'not up to standard',
    grouped: 'To be grouped',
    notissued: 'not issued',
    expired1: 'expired',
  },
  down: {
    softdown: 'Download',
    downmt4: 'Download MT5 trading software/Magic Compass Investment APP and start trading immediately',
    mt4trad: 'MT5 Platform',
    mt4prof:
      'MT5 is a professional trading software that can trade foreign exchange and precious metals at the same time. It integrates the three functions of market charts, technical analysis, and trading operations. It can perform different operations such as placing orders, closing limit orders, stopping losses, taking profits, viewing reports and analyzing data. It is currently One of the most widely used foreign exchange market software. At present, more than 300 brokers and banks around the world are using the MT5 platform as a trading platform, which is the most popular online trading platform in the world.',
    insquot: 'Provide instant quotes',
    simpflex: 'Simple operation and flexible ordering',

    riskfun: 'With risk control functions such as stop loss and profit',
    lockfun: 'With lock function',
    charts: 'Clear and intuitive price charts',
    intuitive: 'Drawing tools and technical analysis indicators are easy to use',
    install: 'Easy to install and takes up less system resources',
    versiond: 'MT5 PC version download',
    scanqr: 'Scan the QR code to download the mobile terminal',
    mcappcon:
      'Magic Compass Investment APP is a mobile phone market software carefully created by our company for customers.Here you can get a full range of domestic and foreign precious metal market, domestic and foreign futures market, global index, financial information and other services. Cool page design, extremely fast data transmission speed, and smooth experience and powerful data information can provide you with more accurate and real-time financial data, market quotes, and exclusive solution comments, so that no matter where you are, you can strategize and enjoy the wisdom of life.',
    marketany: 'View market data anytime, anywhere, data transmission is fast and stable',
    comprehensive: 'Comprehensive and objective technical analysis summary and recommendations',
    economy: 'Macroeconomics to understand the state of the economy',
    quickopen: 'Quick account opening, real-time login, capital injection and withdrawal',
    onemachine: 'One machine in hand, worry-free transaction',
    macapp: 'Magic Compass Investment APP',
  },
  sug: {
    acom: 'Open a New Ticket',
    dissatisfied: 'If you are dissatisfied with our service, please submit a message here, we will reply or deal with it as soon as possible, thank you!',
    title: 'Subject:',
    enttile: 'Please Enter a Title',
    comtype: 'Type of Query:',
    seltype: 'Please Select',

    sersug: 'Suggestions for Service',
    complain: 'About Customer Service',
    problem: 'About Trading Account',
    deposits: 'Deposits and Withdrawals',
    website: 'Website Promotion/Customer Service',
    orderap: 'Trade Order Appeal',

    visit: 'Return Visit Type',
    onlinemeg: 'Online message',
    spe: 'Account Manager to Call Back',
    appointment: 'Appointment',
    sappointment: 'Please Select an Appointment Time',
    sappointments: 'Please Select an Appointment Time!',
    content: 'Description:',
    contentc: 'Description',
    entres: 'Please enter reservation message',
    comret: 'My Ticket',
    moddate: 'Date',
    selvisit: 'Type',
    subtime: 'Submission Time',
    type: 'Type',
    Reply: 'Reply',
    notpro: 'Not Processed',
    replyd: 'Replied',
    over: 'Over',
    blank: 'The subject can not be blank!',
    thanks: 'Thank you for your attention and feedback.Our staff will contact you later, please keep your phone open and wish you a happy life!',
    subsucc: 'Submitted successfully',
  },
  msg: {
    announ: 'Latest Announcement',
    staletter: 'Station Letter',
    contactus:
      'Magic Compass is a globally recognized FX & CFD broker, we are authorised and regulated as an Investment Dealer by the Cyprus Securities and Exchange Commission (CySeC) under License Number 299/16. We offer you the perfect fusion of security, technology, and accessibility to trade CFDs multi-asset classes such as forex, index, oil, metals, and stock.',
    contactus2:
      "Magic Compass offer advanced MT5 platform and self-development trading application for clients, with us, you can join global capital market, experience for fast trading speed,  and gain profits. We also establish strict rules and transparent to quotations, and you can trade CFDs on forex, shares, indices, metals, commodities & cryptocurrencies to satisfy client's demands to the great extent.",
    contactus3:
      'In addition, for the best trading experience to clients, we offer twenty four seven customer service, if there is any question, please free feel to contact us, we will process for you as soon as possible!',
    coninfo: 'Contact Method',
    cusemail: 'Email：cs@prowayxau.com',
    custeleph: 'Hotline：4008423990',
    statistics: 'Statistics：',
    comcus: 'The Number of Direct Clients',
    totaldep: 'Total Deposit:',
    totalde: 'Total Deposit',
    totalwit: 'Total Withdrawals:',
    totalwi: 'Total Withdrawals',
    totalreb: 'Total Rebate:',
    totalre: 'Total Rebate',
    report:
      "This report shows the aggregate data of the entire agency chain under the customer's name (including the customer himself), not the customer's personal data.",
    numcus: 'Number of Clients',
    loginout: 'Are you sure you want to leave client center?',
    tryagain: 'Please try again',
    notsub: 'Non-working hours, temporarily unable to submit withdrawals',
  },
  menu: {
    ib: 'IB',
    sib: 'Sub IBs',
    stics: 'Statistics',
    sions: 'Commissions',
    repview: 'Report',
    rlink: 'Referral Link',

    ainfo: 'Account Information',
    poi: 'Verification Document ',
    bard: 'Bank Card',
    cpass: 'Reset Password',

    mmange: 'Funds Management',
    injects: 'Deposit',
    widraw: 'Withdrawal',
    fdet: 'Statement',
    qbdz: 'Address Manage',
    tradi: 'Trading Information',
    posit: 'Open Positions',
    closep: 'Close Positions',
    actcen: 'Promotions',
    firste: 'First Deposit Promotion',
    servce: 'Service Center',
    down: 'Download',
    sugge: 'Suggestions',
    mymess: 'My Message',
    conus: 'Contact Us',

    invfri: 'Recommend Clients',
    invfris: 'Activity Center',
    bonus: 'BonusDetails',
    setrec: 'SettlementRecord',

    firseven: 'First Deposit Promotion',
    bemail: 'Bind Email',
    changephone: 'Re-bound Mobile Number',
    uc: 'Client Center',
    activityList: 'Event Hall',
    myActivity: 'My Activities',
    activityDetail: 'Activity Details',
  },
  meta: {
    base: 'Client Center',
    phonotblank: 'Phone number cannot be blanked',
    corrpho: 'Please enter correct phone number',
    entemail: 'Please enter email address',
    gpver: 'Go to verification',
    fillmail: 'Please fill in the correct emial address',
    emailnotnull: 'Email cannot be empty',
    querstion: ',If you have any questions, please contact online customer service',
    bounde: 'Email is bound',
    chaemail: 'Reset Email',
    entnewpho: 'Please enter new phone number',
    chapho: 'Change the phone number',
    setp1: 'Step1 Authenticate',
    step2: 'Step2 Bind New Phone Number',
    currentpho: 'The Current Phone Number',
    cuurn: 'The current phone number cannot receive the verification code',
    authcurr: 'Authenticate through the current phone number',
    phobound: 'The phone number has been bound',
    failedem: 'Failed to authenticate, please contact customer service',
    phobeenbound: 'The phone number you provide has been bound',
    Reminder: 'Reminder: We will snet the verification code to your email address',
    mailbox: 'Please check with your mailbox',
    boundsucc: 'Phone number has been bound successfully!',
  },
  active: {
    score: 'My Grades',
    title_span_1: 'Profit And Loss Amount',
    title_span_2: 'Expected to Withdrawal',
    resetButton: 'Apply for a Reset Event',
    h4_title: 'Activity Details',
    status: 'Active Status:',
    starttime: 'Starting Time:',
    endtime: 'End Time:',
    resetnum: 'Remaining Resets:',
    rstprofit: 'Profit and Loss:',
    balance: 'Balance:',
    award: 'Reward Balance:',
    Invalid: 'Invalid request. Please contact the administrator.',
    failed: 'The request failed, please contact the administrator',
    size5: 'The image sizes cannot exceed 5MB.',
    upfail: 'Upload Failure',
    failgetimg: 'Failed to get image address',
    Scantopay: 'Scan to pay',
    infver: 'Information verification',
    china: 'China',
    activityStatus: ['Ongoing', 'over', 'registering'],
    detailsState: ['Ongoing', 'completed'],
  },
  banck: {
    addcard: 'Add a Bank Card',
    cardholder: "Cardholder's Name:",
    bankpro: 'Bank Card Province:',
    Branch: 'Branch/Branch Name',
    submitting: 'We will review your bank card after you submitting, and then you can use it to withdrawal.',
    approved: 'If you would like to change bank card after we approved, please contact us',
    funding: 'For the funding security reason, please ensure the information is correct.',
    digit: 'Please enter 16-19 digit bank card number',
    phonenum: 'Please enter the phone number',
    digit11: 'Please enter an 11-digit mobile phone number',
    otherbanks: 'Other Banks',
    bankinfoma: 'Bank Card Information',
    shared: 'Shared',
    verify: 'A bank card/Verify up to * bank card',
    piece: 'piece',
    Reserved: 'Reserved mobile number',
    Safestate: 'Safe state',
    Remove: 'Remove',
    bankdetail: 'bank card details',
    BankName: 'Bank Name:',
    cardholde: 'cardholder:',
    Reserve: 'Reserve a mobile phone',
    Verification: 'Verification time',
    cerstatus: 'Certification status',
    keepone: 'Keep at least one authentication card',
    curcontinue: 'This operation will remove the current bank card from the list, do you want to continue?',
    Note: 'Note',
    remsuc: 'Removing succeed',
    Cancelled: 'Cancelled',
    ver3card: 'Verify up to 3 bank card',
    bindexist: 'Bind an existing real account',
    bindexistd: 'Bind an existing demo account',
    acc: 'account number',
    entyacc: 'please enter your account number',
    password: 'password',
    bindnow: 'bind now',
    actdemoacc: 'Active demo account',
    virtra:
      'It is a virtual online trading account. The funds in the account are virtual. Commodities, quotations, charts, and trading are all synchronized with the real trading system in real time. It is the best training ground for beginners to start precious metal trading.',
    Realname: 'Real name',
    entyourrn: 'please enter your full name',
    China: 'China',
    chihk: 'Hong Kong, China',
    chimac: 'Macao, China',
    chitw: 'Taiwan, China',
    othcoun: 'Other countries and regions',
    setpassword: 'set password',
    promnum: 'Promotion number',
    entpronum: 'Please enter the promotion number (optional)',
    mobilephone: 'mobile phone',
    noacctoopen: 'No real account, go to open an account',
    nodemoacc: 'No demo account, go to open an account',
    notblank: 'Name cannnot be blanked',
    incfor: 'Incorrect name format!',
    idnumnotblank: 'ID number cannot be blanked',
    entidcorr: 'Please enter the ID number correctly',
    idbeenreg: 'ID number has been registered!',
    pasnotempty: 'Password cannot be blanked',
    invformat: 'Invalid Account Format',
    pass6: 'Password needs to have at least 6 characters',
    youaccis: 'Your real account is',
    activation: 'Your account has been activation',
    demoacc: 'Your demo account is',
    inviterew: 'Invite Reward',
    Invitee: 'Invitee:',
    nameacc: 'Please enter name/trading account number',
    invnumb: 'Number of invitees/person',
    activenump: 'Activation number/person',
    trewards: 'Transaction Rewards',
    continutrading: 'Continuous Trading Rewards',
    rewards: 'generate rewards',
    inviterews: 'Invite reward',
    bindinvcode: 'Bind invitation code',
    enterinvite: 'Please enter the invitation code',
    bind: 'bind',
    Invitepeople: 'Invite people',
    Rewconsecutive: 'Rewards for consecutive trades reached',
    Eightweek: 'Eight-week trading lot statistics',
    Eightweekcou: 'Eight week countdown',
    BasicInfor: 'Basic Information',
    accoptime: 'Account opening time',
    earntime: 'Earning time',
    gentrarewards: 'Generated trading rewards',
    day180lots: '180day trading lots',
    day180down: '180day countdown',
    Continuous: 'Continuous',
    weeklots: 'Weekly closing lots',
    cangethand: 'Time of hand, both parties can get',
    invcodenotempty: 'Invitation code cannot be empty',
    earnedon9: 'Calculate the rewards earned on the previous day at 9:00am every day',
    accumrews: 'Accumulated rewards',
    rewardsstet: 'Rewards to be settled',
    rewandsetl: 'Rewards and settlement',
    numofinvite: 'Number of invitees',
    yesterdayrew: "Yesterday's settlement reward",
    promocode: 'My promo code',
    clicksave: 'Click to save the QR code',
    promotion: 'Your promotion code is',
    copypromo: 'Click to copy promotion code',
    promolink: 'Your promotion link is',
    copylink: 'Click to copy promotion link',
    procodebind: 'Promotion code: copy and send it to the invitee, and the invitee can bind it in the user centre;',
    prolinkcopy:
      'Promotion link: After copying, you can send it to the invitee, and the invitee will successfully open an account through the link and automatically bind;',
    qrcodesave:
      'QR code: Click the QR code to save the picture, and the invitee will automatically bind after scanning the code to open an account successfully.',
    accnotactive: 'The account has not been activated and cannot use the promotion function',
    activatedt: 'Account activated. Use my promotion code',
  },
  set: {
    settleteime: 'Settlement Time',
    setamo: 'settlement Amount',
    stpset: 'STP',
    ecnset: 'ECN',
    indexclass: 'Index Class',

    frebate2: 'Forex Rebate',
    srebtae2: 'Stock Rebate:',
    chinar300s: 'CHINA300 Rebate：',
    chinar50s: 'CHA50 Rebate',
    rebates2: 'Other index Rebates:',
    comclass2: 'Commodity Class',
    lgrebate2: 'GOLD Rabate:',
    lsrebate2: 'SILVER Rabate',
    usoilrebate2: 'USOIL Rabate:',
    ukoilrebate2: 'UKOIL Rabate',
    cryrebates2: 'Cryptocurrency Rebates:',
    btccomm2: 'BTC100x Rabate:',
    otherrebates2: 'Other Cryptocurrency Rebates:',
    Group: 'Group',
    groper: 'Group Permission',

    ukoilrab: 'Please enter UKOIL rabate',
    correbate: 'Please enter the correct rebate of UKOIL',
    '': 'Setting UKOIL rebate cannot large than set point of upper IB',
    entcha300: 'Please enter CHINA300 rabate',
    entcorcha300: 'Please enter the correct rebate of CHINA300',
    entcha50: 'Please enter CHA50 rabate',
    entcorcha50: 'Please enter the correct rebate of CHA50',
    entusoilr: 'Please enter USOIL rabate',
    encortusoilr: 'Please enter the correct rebate of USOIL',
    entfxr: 'Please enter FX rebate',
    entcorfx: 'Please enter the correct rebate of FX',
    entxauusd: 'Please enter GOLD rebate',
    entcorxauusd: 'Please enter the correct rebate of GOLD',
    entothindex: 'Please enter other index rebates',
    entcorindex: 'Please enter the correct rebate of  other Index',
    entxagusdr: 'Please enter SILVER rebate',
    entcorxagusd: 'Please enter the correct rebate of  SILVER',
    stockrebate: 'Please enter stock rebate',
    entcorstock: 'Please enter the correct rebate of  stock',
    btc100rebate: 'Please enter BTC100x rebate',
    btc100cor: 'Please enter the correct rebate of  BTC100x',
    otherrebate: 'Please enter other cryptocurrencies rebate',
    corofcrypt: 'Please enter the correct rebate of  other cryptocurrencies',

    ukoilrebate: 'Setting UKOIL rebate cannot large than set point of upper IB',
    chi300: 'Setting CHINA300 rebate cannot large than set point of upper IB',
    chi50: 'Setting CHA50 rebate cannot large than set point of upper IB',
    usoilrebate: 'Setting USOIL rebate cannot large than set point of upper IB',
    fxrebate: 'Setting FX rebate cannot large than set point of upper IB',
    xauusdrebate: 'Setting GOLD rebate cannot large than set point of upper IB',
    stockrebates: 'Setting stock rebate cannot large than set point of upper IB',
    btc100rebates: 'Setting BTC100x rebate cannot large than set point of upper IB',
    cryptos: 'Setting crypto rebate cannot large than set point of upper IB',
    indexrebates: 'Setting index rebate cannot large than set point of upper IB',
    xagusdreabage: 'Setting SILVER rebate cannot large than set point of upper IB',

    pre: 'the previous',
    next: 'the next',
    trebates: 'Total Rebate',
    promocode: 'Promo Code',

    sotr: 'Settlement of Total Rebate',
    sor: 'Settlement of Rebate $',
    soc: 'settlement of Commission $',
    ss: 'Settlement Status',
    rr: 'Rebate Rules',
    cry: 'Cryptocurrency',
    stpview: 'Click here to view STP product data',
    ecnview: 'Click here to view ECN product data',
    reflink: 'Referral Link:',
    stpnocom: 'STP Standard Account/No Commissions',
    stp10usd: 'STP Standard Account/ Commission Charges 10 USD per 1 lot',
    stp20usd: 'STP Standard account/ Commission Charges 20 USD per 1 lot',
    stp30usd: 'STP Standard account/ Commission Charges 30 USD per 1 lot',
    stp40usd: 'STP Standard account/ Commission Charges 40 USD per 1 lot',
    stp50usd: 'STP Standard account/ Commission Charges 50 USD per 1 lot',
    ecnlowspread: 'ECN Low Spread Account / Commission Charges 10 USD per 1 lot',
  },
  fx: {
    Forex: 'Forex',
    Stock: 'Stock',
    index: 'Index Class',
    btc: 'Bitcoin',
    otherbtc: 'Cryptocurrencies',
    Commission: 'Total Commission',
    deposit: 'Deposit',
    withdraw: 'Withdraw money',
    withd: 'Please select a withdrawal method first',
    failedobtbank: 'Failed to obtain bank card information, please refresh the page and try again',
    failedobt: 'Failed to get coin address information, please refresh the page and try again',
    fristup: 'Please upload the collection code first.',
    insbal: 'Insufficient Balance',
    balove: 'Time Out',
    conf: 'Please Confirm',
    mt4suc: 'MT5 Success',
    processing: 'Processing',
    min5: 'The minimum amount is 5 USD',
    correctamo: 'Please enter correct amount',
    maxamount: 'The maximum amount of withdrawal',
    errgetbal: 'Failed to get balance',
    faildcny: 'Failed to withdrawal in CNY',
    wallet: 'Digital wallet',
    nodemoac: 'No demo account yet',
    suc: 'Success',
    tout: 'Time out, please login again',
    numofdircli: 'Direct client',
    numofsubid: 'IB client',
    recivemail: 'The verification code has been sent, please log in to view',
  },
  wal: {
    def: 'Default',
    noadd: 'No Address',
    add: 'Add',
    rightadd:
      'Please ensure the wallet address is provided correctly. Financial losses resulted from the wrong wallet address provided by you, Magic Compass will not take any responsibilities.',
    edit: 'Edit',
    del: 'Delete',
    address: 'Address',
    addadr: 'Add new address',
    chain: 'Chain Name',
    wal: 'Wallet address',
    waladd: 'Please enter your wallet address',
    com: 'For easy to use and management, you can input the brief description.',
    defadd: 'Set your default wallet address',
    riaddr: 'Please enter the correct wallet address!',
    edadd: 'Edit wallet address',
    addaddr: 'Add wallet address',
    deladdr: 'Are you sure delete the wallet address?',
    sucdel: 'Deleted successfully!',
    chaalr: 'Undeleted',
    alre: 'We have already deducted',
    alre1: 'USD bonus as you do not complete trading lots of promotions',
  },
  act: {
    fbon: 'First Deposit Bonus',
    bonamount: 'Bonus Amount',
    lots: 'Lots',
    stime: 'Start Time',
    etime: 'End Time',
    prosta: 'Promotion Status',
    nis: 'Not issued',
    isuse: 'Issued',
    comp: 'Completed',
    ded: 'Deducted',

    gifta: 'Gift Away',
    gift: 'Gift',
    giftstatus: 'Gift Status',
    concus: 'Get a gift, please contact customer service!',

    nogroup: 'No Group',
    noncon: 'Non-conforming',
    complate: 'Completed',
    expi: 'Expired',

    rece: 'Received',
    notget: 'Not Get',
    twbon: 'First Deposit Bonus',
    reces: 'Promotion Level',
    depamo: 'Deposit Amount:',
    prost: 'Promotion Status: ',
    fdt: 'First Deposit Time:',
    cut72: 'Cut Off Time:',
  },
  tra: {
    rtime: 'Registration Time:',
    etime: 'Closing Date:',
    lev: 'Present Level:',
    gift: 'Trading bonus activities',
    over: 'Over',
    Dollar: '$',
    limit: 'If your withdrawal less than $1000 USD, please select USDT TRC20',
  },
}



// WEBPACK FOOTER //
// ./src/lang/en.js